import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "./common";

export interface PolicyImprovementItem {
    policy_id: string;
    policy_change: string;
    approver?: string | null;
    implementation_date?: string | null;
    comments?: string | null;
    ai_generated?: boolean | null;
    user_updated?: boolean | null;
    last_updated_at: string;
}

export interface PolicyImprovementItemUI extends PolicyImprovementItem {
    is_added: boolean;
    is_dirty: boolean;
}

export interface PolicyImprovementListResponse {
    policy_improvements: PolicyImprovementItem[];
}

export interface UpsertPolicyImprovementsRequest {
    policy_improvements: PolicyImprovementItem[];
}

const PolicyImprovementsAPI = {
    get: async (caseId: string): Promise<PolicyImprovementListResponse> => {
        const response: AxiosResponse<PolicyImprovementListResponse> =
            await axiosInstance.get(`v1/cases/${caseId}/policy-improvements`);
        return response.data;
    },

    upsert: async (
        caseId: string,
        request: UpsertPolicyImprovementsRequest
    ): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.put(`v1/cases/${caseId}/policy-improvements`, request);
        return response.data;

    },

    delete: async (
        caseId: string,
        policyId: string
    ): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.delete(
                `v1/cases/${caseId}/policy-improvements/${policyId}`
            );
        return response.data;
    },
};

export default PolicyImprovementsAPI;